import React, { useEffect, useState, useRef } from 'react'
import MenuBar from '../Menu/Menu';
import FreeTrial from '../FreeTrial/FreeTrial'
import {Link, Outlet, useParams} from "react-router-dom"

import {ContentBoxStyled} from "../../../styled/Container";
import BubbleFloat from "../BubbleFloat/BubbleFloat";
import Testimonials from "../Testimonials/Testimonial";
import Companies from "../TopCompanies/Companies";
import FAQ from "../FAQ/FAQ";
import SubscriptionPlans from "../SubscriptionPlans/Subscriptions";
import Footer from "../Footer/Footer";
import featureTutorial from "../Learn/data";
import {useTheme} from "../Theme/ThemeContext";
import { FaArrowRight } from "react-icons/fa";


const ResumeLearnMore = () => {
    const [bubbleText, setBubbleText] = useState(['B', 'u', 'b', 'b', 'l', 'e', ' ', 'A', 'i']);
    const bubbleTextRef = useRef(null);
    const isAuth = localStorage.getItem('isAuth');
    const params = useParams();
    const noSpecificRequest = Object.keys(params).length < 1;
    const {themeName} = useTheme();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (bubbleTextRef.current) {
          bubbleTextRef.current.style.animation = 'none';
          void bubbleTextRef.current.offsetWidth; // Trigger a reflow
          bubbleTextRef.current.style.animation = null;
        }
    }, [bubbleText]);

    const handleTryFree = (link) => {
        sessionStorage.setItem("prevPath", link)
        window.open('/join-bubble', '_blank');
    }

    return (
        <div style={{width: '100vw', boxSizing: 'border-box'}}>
            <BubbleFloat/>
            <MenuBar />

            <ContentBoxStyled theme={themeName}>
                {!isAuth && (
                    <FreeTrial />
                )}

                {!noSpecificRequest && <div ref={bubbleTextRef}>

                    <Outlet
                        context={{ handleTryFree }}
                    />
                </div>}

                {noSpecificRequest && (
                    <>
                        <div className="links">
                            <h3>Topics</h3>
                            <ol>
                                {featureTutorial.map((item, index) => (
                                    <li key={index}>
                                        <Link to={item.slug}>
                                            {item.title} <FaArrowRight/>
                                        </Link>
                                    </li>
                                    )
                                )}
                            </ol>
                        </div>



                        <Testimonials/>

                        <Companies/>

                        <FAQ/>

                        <SubscriptionPlans/>

                        <Footer/>

                    </>
                 )}

            </ContentBoxStyled>


        </div>
    )
}

export default ResumeLearnMore;